module.exports = __webpack_public_path__ + "static/branding-79dac87b4f16f6c2fdecda806a77f347.webp";